module.exports = __webpack_public_path__ + "logo-black.2576558107b55309ea9f0bbad08acb1a.svg";